import { render } from "./Crear-Producto.vue?vue&type=template&id=04d51032&scoped=true"
import script from "./Crear-Producto.vue?vue&type=script&lang=js"
export * from "./Crear-Producto.vue?vue&type=script&lang=js"

import "./Crear-Producto.vue?vue&type=style&index=0&id=04d51032&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d51032"]])

export default __exports__